import React from 'react'
import { FormPanelPlan, FormPanelPlanDesc, FormPanelPlanDetails, FormPanelPlanLink, FormPanelPlanSubtitle, FormPanelPlanTitle, FormPanelPlanWrapper } from '../../styles/FormPlanCard.Styled'

function FormPricingPlan(props) {
  return (
    <FormPanelPlan className={props.plan.selected?'active':''}>
        <FormPanelPlanWrapper>
          <FormPanelPlanDetails>
            <div>
                <img src={props.plan.icon} alt={props.plan.name}/>
            </div>
            <FormPanelPlanSubtitle>{props.plan.name}</FormPanelPlanSubtitle>
            <FormPanelPlanTitle>₦{props.plan.amount} <span> /{props.plan.period}</span></FormPanelPlanTitle>
            <FormPanelPlanDesc>{props.plan.description}</FormPanelPlanDesc>
          </FormPanelPlanDetails>
          <FormPanelPlanLink onClick={props.onPlanButton}>Choose {props.plan.name}</FormPanelPlanLink>
        </FormPanelPlanWrapper>
    </FormPanelPlan>
  )
}

export default FormPricingPlan